import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';

/**
 * Attaches the current Clerk user to all Sentry events.
 * When an error happens you see who was logged in (id, email, role).
 */
export function SentryUserProvider({ children }: { children: React.ReactNode }) {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username || undefined,
      });
      Sentry.setTag('user_role', (user.publicMetadata?.role as string) || 'landlord');
    } else {
      Sentry.setUser(null);
    }
  }, [user, isLoaded]);

  return <>{children}</>;
}

export default SentryUserProvider;
